<header class="header">
  <div class="logo" routerLink="/dashboard" routerLinkActive="active">
    <img src="assets/images/icons/kpmg-logo.svg" alt="KPMG LOGO" />
  </div>
  <div class="title">{{ appName }}</div>
  <div class="action-button">
    <button mat-button aria-label="knowledge-assistant" class="small-button" [matTooltip]="knowledgeToolTip"
      (click)="openLink()">
      <img src="assets/images/icons/outline.png" alt="KPMG LOGO" />
    </button>
    <button mat-button aria-label="search" class="small-button" routerLinkActive="active">
      <img src="assets/images/icons/search.svg" alt="KPMG LOGO" />
    </button>
    <app-notification-status-button></app-notification-status-button>

    <button mat-button class="small-button" aria-label="settings" *ngIf="userService.userHasPlatformAdminRole"
      (click)="closeAllMenusApartSetting()" [matMenuTriggerFor]="settingsMenu" #settingsTrigger="matMenuTrigger">
      <img class="setting-logo" src="assets/images/icons/admin-setting.svg" alt="Settings" />
    </button>

    
    <button mat-button aria-label="User Profile Menu" class="user-profile-menu-button" [matTooltip]="username"
      (click)="closeAllMenuApartProfile()" [matMenuTriggerFor]="userProfileMenu" #userProfileTrigger="matMenuTrigger">
      <img src="assets/images/icons/user-profile.svg" alt="Profile Icon" />
    </button>

    <mat-menu #settingsMenu="matMenu">
      <button mat-menu-item routerLink="/admin/project-type">
        <div class="menu-icon-list">
          <mat-icon>
            <img src="assets/images/icons/view-admin-panel.svg" />
          </mat-icon>
          <span>View Admin Panel</span>
        </div>
      </button>
    </mat-menu>

    <mat-menu #userProfileMenu="matMenu">
      <button mat-menu-item (click)="onLogout()">
        <mat-icon aria-hidden="true" fontIcon="logout" color="primary"></mat-icon>
        Logout
      </button>
    </mat-menu>
  </div>
</header>